
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '监管方式简称',
value: this.$route.params.Item.PSM_Name_Abbr
}, {
label: '监管方式全称',
value: this.$route.params.Item.PSM_Name
}, {
label: '监管方式说明',
value: this.$route.params.Item.PSM_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/SuperviseToolsDetail.vue